/* eslint-disable react/prop-types */
import React from 'react';
import { Select } from 'antd';

const defaultFilterOption = (input, option) =>
  String(option?.children ?? '')
    .toLowerCase()
    .includes(String(input).toLowerCase());

const noopSearch = () => {};

/**
 * Same Select shell as Client / Final Client on the create-project modal:
 * className, search, filter — intentionally no size="large" so height matches those fields.
 * Extra `className` is merged (spread `className` must not replace `client-select`).
 */
const ClientLikeSelect = ({
  filterOption = defaultFilterOption,
  onSearch = noopSearch,
  showSearch = true,
  className,
  children,
  ...rest
}) => (
  <Select
    className={['client-select', className].filter(Boolean).join(' ')}
    showSearch={showSearch}
    optionFilterProp={showSearch ? 'children' : undefined}
    filterOption={showSearch ? filterOption : undefined}
    onSearch={showSearch ? onSearch : undefined}
    {...rest}
  >
    {children}
  </Select>
);

export default ClientLikeSelect;
